import { Zilliqa } from '@zilliqa-js/zilliqa';

export const zilliqa = new Zilliqa('https://api.zilliqa.com/');
